module.exports = __webpack_public_path__ + "img/hospital.8664da14.png";